import React from 'react';
import './NextSteps.css';

interface NextStepsProps {
  steps?: string[];
}

const NextSteps: React.FC<NextStepsProps> = ({ steps = [] }) => {

  if (steps.length === 0) return null;

  const CheckIcon = () => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.97278 14.3281C5.59778 14.3281 5.27747 14.1615 5.01184 13.8281L0.964967 8.76562C0.866008 8.64583 0.793092 8.52865 0.746217 8.41406C0.70455 8.29948 0.683717 8.18229 0.683717 8.0625C0.683717 7.79167 0.772258 7.56771 0.949342 7.39062C1.13163 7.21354 1.3608 7.125 1.63684 7.125C1.95455 7.125 2.22278 7.26823 2.44153 7.55469L5.94153 12.0469L12.7228 1.27344C12.8426 1.09115 12.965 0.963542 13.09 0.890625C13.215 0.8125 13.3764 0.773438 13.5743 0.773438C13.8452 0.773438 14.0665 0.859375 14.2384 1.03125C14.4103 1.19792 14.4962 1.41667 14.4962 1.6875C14.4962 1.79688 14.478 1.90885 14.4415 2.02344C14.4051 2.13281 14.3478 2.25 14.2697 2.375L6.9259 13.8203C6.69674 14.1589 6.37903 14.3281 5.97278 14.3281Z" fill="#0442BF" />
    </svg>

  );

  return (
    <div className="next-steps">
      <h2 className="section-title">Recommended Next Steps</h2>

      <div className="steps-timeline">
        {steps.map((step, index) => (
          <div key={index} className="step-item">
            <div className="step-indicator">
              <div>
                <CheckIcon />
              </div>
            </div>

            <div className="step-content">
              <p className="step-description">{step}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NextSteps;